export enum SpaTreatmentFormStepEnum {
  AVAILABILITY = 'treatmentAvailabilityStep',
  GUESTS = 'guestDetailsStep',
  CUSTOMISE = 'customiseTreatmentStep',
}
